// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1r7to","content":"styles_content__1MTSU","selectAll":"styles_selectAll__2JJv7"};